import moment from "moment";

/* 
------- this function takes care of filtering new data like new customers, new distributors
-------- you get the point
 */
export function FilterNewData(dataList) {
  let filteredArray = [];
  if (dataList) {
    dataList.data.forEach((singleData) => {
      const oneDay = 24 * 60 * 60 * 1000;
      let createdDate = new Date(singleData.createdAt);
      // console.log(createdDate);
      let totalDays = Math.round(Math.abs((createdDate - Date.now()) / oneDay));
      // console.log(totalDays);
      if (totalDays < 14) {
        singleData.new = true;
      } else {
        singleData.new = false;
      }
      filteredArray.push(singleData);
    });
    // select only where new = true
    let trueEleArr = [];
    filteredArray.forEach((arrElement) => {
      if (arrElement.new) {
        trueEleArr.push(arrElement);
      }
    });
    dataList.data = trueEleArr;
    dataList.totalRecords = dataList.data.length;
    return dataList;
  }
  return dataList;
}

export function filterNewData14DaysAgo(dataList) {
  let filteredArray = [];
  let newDataList = [];
  if (dataList) {
    dataList.data.forEach((singleData) => {
      const oneDay = 24 * 60 * 60 * 1000;
      let createdDate = new Date(singleData.createdAt);
      // console.log(createdDate);
      let totalDays = Math.round(Math.abs((createdDate - Date.now()) / oneDay));
      // console.log(totalDays);
      if (totalDays < 14) {
        singleData.new = true;
      } else {
        singleData.new = false;
      }
      filteredArray.push(singleData);
    });
    // select only where new = true

    filteredArray.forEach((arrElement) => {
      if (arrElement.new) {
        newDataList.push(arrElement);
      }
    });
    return newDataList;
  }
  return newDataList;
}

/* 
  ------- custom labels for paginations
  -------- this object is used in the paginationMixin
   */
export const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};

/* 
  ------- this function takes care of filtering 
  -------- you get the point
   */
export function FilterActive(dataList) {
  let newList = [];
  dataList.data.forEach((center) => {
    if (center.isActive) {
      newList.push(center);
    }
  });
  dataList.data = newList;
  dataList.totalRecords = dataList.data.length;
  return dataList;
}

export function FilterActiveStatus(dataList) {
  let newList = [];
  dataList.data.forEach((center) => {
    if (center.status) {
      newList.push(center);
    }
  });
  dataList.data = newList;
  dataList.totalRecords = dataList.data.length;
  return dataList;
}

export function FilterInactive(dataList) {
  let newList = [];
  dataList.data.forEach((center) => {
    if (!center.isActive) {
      newList.push(center);
    }
  });
  dataList.data = newList;
  dataList.totalRecords = dataList.data.length;
  return dataList;
}

export function FilterInactiveStatus(dataList) {
  let newList = [];
  dataList.data.forEach((center) => {
    if (!center.status) {
      newList.push(center);
    }
  });
  dataList.data = newList;
  dataList.totalRecords = dataList.data.length;
  return dataList;
}

export function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function formatDate(dateString) {
  if (!dateString) return "Date not available";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getRelativeTime(dateString) {
  if (!dateString) return "-";

  const time = moment(dateString);
  return time.fromNow();
}

export const getFileDownloadUrl = (fileDownloadPath) => {
  if (!fileDownloadPath) return null;
  return `${process.env.VUE_APP_ZHULIA_SELLER_CENTER_URL}/${fileDownloadPath}`;
};

export function getInitials(name) {
  if (!name) return "";
  const words = name.split(" ");
  return words
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}

export function formatAmount(value, currency) {
  if (isNaN(value)) return "N/A";
  // check the url if its kenya use kes else use ghs
  if(window) {
    const url = window.location.href;
    if (url.includes("kenya")) {
      currency = "KES";
    } else {
      currency = "GHS";
    }
  } else {
    currency = "";
  }
  
  const formattedNumber = Number(value).toLocaleString(currency, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return formattedNumber;
}

export const invoiceStatus = {
  0: "Pending",
  1: "Partially Paid",
  2: "Paid",
  3: "Overdue",
  4: "Critically Overdue",
  5: "Cancelled",
};

export const orderStatus = {
  0: "Awaiting Confirmation",
  1: "Awaiting Fulfillment",
  2: "Ready For Dispatch",
  3: "Complete",
  4: "Canceled",
  5: "Received",
};

export const orderStatusFilters = [
  { label: orderStatus[0], value: 0},
  { label: orderStatus[1], value: 1},
  { label: orderStatus[2], value: 2},
  { label: orderStatus[3], value: 3},
  { label: orderStatus[4], value: 4},
  { label: orderStatus[5], value: 5},
];

export const FulfilmentTypeFilters = [
  {  label: "FBS", value: "FBS"},
  {  label: "FBC", value: "FBC"}
]

export const DeliveryMethodMap = {
  0: "Pick-up",
  1 : "Delivery",
};

export const documentApprovalPropertyMap = {
  "Certificate of Registration": "Businesscertificate",
  "Proof of Payment": "ProofOfPayment",
  "National ID Card": "NationalId"
};


